(function() {
	'use strict';

	angular.module('telestatApp').controller(
			'AdvertisingSourceConversionReportController',
			AdvertisingSourceConversionReportController);

	AdvertisingSourceConversionReportController.$inject = [ '$scope', '$state',
			'$sce', '$translate', 'AdvertisingSourceConversionReport',
			'Division', 'ParseLinks', 'AlertService', 'paginationConstants',
			'pagingParams', 'UIFormAccess', '$filter' ];

	function AdvertisingSourceConversionReportController($scope, $state, $sce,
			$translate, AdvertisingSourceConversionReport, Division,
			ParseLinks, AlertService, paginationConstants, pagingParams,
			UIFormAccess, $filter) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerLargePage;
		vm.clear = clear;
		vm.search = search;
		vm.loadAll = loadAll;
		vm.searchQuery = pagingParams.search;
		vm.currentSearch = pagingParams.search;

		vm.division = {
			id : pagingParams.divisionId
		};

		var allDivisionsTranslate = $translate
				.instant('telestatApp.reportsCommon.allDivisions');
		vm.divisions = [ {
			id : null,
			actual : 1,
			title : allDivisionsTranslate
		} ];
		Division.getforselect({}, function(data) {
			var divTree = makeFlatDivisionList(data, 0);
			vm.divisions = vm.divisions.concat(divTree);
		});

		vm.exportLink = '';
		vm.UIFormAccess = UIFormAccess;

		vm.dateFilterData = {
			search : search,
			pagingParams : pagingParams,
			initCallBack : loadAll
		};

		vm.reportClean = [];
		vm.report = [];
		vm.mainIdColumn = 'nameId';
		vm.mainColumn = 'advertisingSourceName';
		vm.totalData = {
			uniqueLeadCount : 1,
			targetedCount : 1,
			missedCount : 1,
			productCount : 1
		};
		vm.diagramOptions = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.uniqueLeadCount * 100
										/ vm.totalData.uniqueLeadCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.uniqueLeadCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsTarg = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.targetedCount * 100
										/ vm.totalData.targetedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.targetedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsMissed = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.missedCount * 100
										/ vm.totalData.missedCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.missedCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};
		vm.diagramOptionsProd = {
			chart : {
				type : 'pieChart',
				height : 300,
				x : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d[vm.mainColumn]
								+ " ("
								+ Math.round(d.productCount * 100
										/ vm.totalData.productCount) + "%)";
				},
				y : function(d) {
					if (d[vm.mainIdColumn] != null)
						return d.productCount;
				},
				showLabels : false,
				showValues : true,
				duration : 500,
				legendPosition : 'top',
				labelThreshold : 0.01
			// labelSunbeamLayout: true,
			}
		};

		function makeLink() {
			var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
			vm.exportLink = "sort="
					+ sortResult
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&startDate='
									+ $filter('date')(
											vm.dateFilterData.startDate,
											"yyyy-MM-dd", 0))
					+ (vm.dateFilterData.dateFilterType == 'all' ? ''
							: '&endDate='
									+ $filter('date')(
											vm.dateFilterData.endDate,
											"yyyy-MM-dd", 0))
					+ (vm.division == null || vm.division.id == null ? ''
							: '&divisionId=' + vm.division.id);
		}
		makeLink();

		function loadAll() {
			makeLink();
			AdvertisingSourceConversionReport.query({
				query : pagingParams.search,
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort(),
				// search with time limits
				startDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.startDate,
								"yyyy-MM-dd", 0),
				endDate : vm.dateFilterData.dateFilterType == 'all' ? null
						: $filter('date')(vm.dateFilterData.endDate,
								"yyyy-MM-dd", 0),
				divisionId : vm.division == null ? null : vm.division.id
			}, onSuccess, onError);

			function sort() {
				var result = [ vm.predicate + ','
						+ (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.report = data;
				vm.minData = {};
				vm.maxData = {};
				getMinMax(vm.minData, vm.maxData, data);
				for (var i = 0; i < vm.report.length; i++) {
					if (vm.report[i][vm.mainIdColumn] == -1) {
						vm.totalData = vm.report[i];
						break;
					}
				}
				postMinMax();
			}
			function onError(error) {
				var headers = Object
						.keys(error.headers())
						.filter(
								function(header) {
									return header.indexOf('app-alert',
											header.length - 'app-alert'.length) !== -1
											|| header
													.indexOf(
															'app-params',
															header.length
																	- 'app-params'.length) !== -1;
								}).sort();
				var alertKey = error.headers(headers[0]);
				if (angular.isString(alertKey)) {
					AlertService.warning(alertKey, {
						param : error.headers(headers[1])
					});
				}
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {

			vm.dateFilterData.updateDateFilterType();
			$state
					.transitionTo(
							$state.$current,
							{
								page : vm.page,
								sort : vm.predicate + ','
										+ (vm.reverse ? 'asc' : 'desc'),
								search : vm.currentSearch,
								// search with time limits
								searchType : vm.dateFilterData.dateFilterType,
								startDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.startDate,
										"yyyy-MM-dd", 0)
										: null,
								endDate : vm.dateFilterData.dateFilterType == 'day'
										|| vm.dateFilterData.dateFilterType == 'range' ? $filter(
										'date')(vm.dateFilterData.endDate,
										"yyyy-MM-dd", 0)
										: null,
								divisionId : vm.division == null ? null
										: vm.division.id
							});
		}

		function search(searchQuery) {
			if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
				return vm.clear();
			} else if (!searchQuery) {
				vm.currentSearch = null;
			} else {
				vm.predicate = 'advertisingSourceName';
				vm.reverse = false;
				vm.currentSearch = searchQuery;
			}
			vm.links = null;
			vm.page = 1;
			vm.transition();
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.predicate = 'advertisingSourceName';
			vm.reverse = false;
			vm.currentSearch = null;
			vm.dateFilterData.setFilterType('all');
			vm.transition();
		}

		// Main columns list
		vm.columns = [ 'advertisingSourceName', 'callsCount',
				'uniqueLeadCount', 'undefCount', 'insignifCount',
				'targetedCount', 'missedCount', 'uselessCount', 'productCount',
				'avgTalkQuality', 'avgServiceQuality' ];
		// Paired columns
		vm.addcolumns = [];
		vm.addcolumns['uniqueLeadCount'] = 'uniqueLeadPercent';
		vm.addcolumns['undefCount'] = 'undefPercent';
		vm.addcolumns['insignifCount'] = 'insignifPercent';
		vm.addcolumns['targetedCount'] = 'targetedPercent';
		vm.addcolumns['missedCount'] = 'missedPercent';
		vm.addcolumns['uselessCount'] = 'uselessPercent';
		vm.addcolumns['productCount'] = 'productPercent';
		// Percent columns value for css
		vm.pColumn = [];
		vm.pColumn['uniqueLeadCount'] = 'uniqueLeadPercent';
		vm.pColumn['undefCount'] = 'undefPercent';
		vm.pColumn['insignifCount'] = 'insignifPercent';
		vm.pColumn['targetedCount'] = 'targetedPercent';
		vm.pColumn['missedCount'] = 'missedPercent';
		vm.pColumn['uselessCount'] = 'uselessPercent';
		vm.pColumn['productCount'] = 'productPercent';
		vm.pColumn['avgTalkQuality'] = 'avgTalkQuality';
		vm.pColumn['avgServiceQuality'] = 'avgServiceQuality';
		vm.pColumn['callsCount'] = 'callsCountP';// Special column name

		// Highlighting columns by min/max
		vm.columnsMinMax = [ 'callsCount', 'uniqueLeadCount', 'undefCount',
				'undefPercent', 'insignifCount', 'insignifPercent',
				'targetedCount', 'targetedPercent', 'missedCount',
				'missedPercent', 'uselessCount', 'uselessPercent',
				'productCount', 'productPercent', 'uniqueLeadPercent',
				'avgTalkQuality', 'avgServiceQuality' ];
		// Inverse min/max on next columns.
		vm.inverseColumns = {
			'undefCount' : 1,
			'undefPercent' : 1,
			'insignifCount' : 1,
			'insignifPercent' : 1,
			'uselessCount' : 1,
			'uselessPercent' : 1,
			'missedCount' : 1,
			'missedPercent' : 1
		};

		function getMinMax(min, max, rows) {
			var val = 0;
			vm.reportClean = [];
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				if (row[vm.mainIdColumn] == -1)
					continue;
				vm.reportClean.push(row);
				if (val == 0) {
					val = 1;
					vm.columnsMinMax.forEach(function(name) {
						min[name] = row[name];
						max[name] = row[name];
					});
					continue;
				}
				vm.columnsMinMax.forEach(function(name) {
					if (row[name] !== null) {
						if (max[name] === null)
							max[name] = row[name];
						if (min[name] === null)
							min[name] = row[name];
						if (vm.inverseColumns[name] === 1) {
							if (max[name] > row[name])
								max[name] = row[name];
							if (min[name] < row[name])
								min[name] = row[name];
						} else {
							if (max[name] < row[name])
								max[name] = row[name];
							if (min[name] > row[name])
								min[name] = row[name];
						}
					}
				});
			}
		}
		function postMinMax() {
			for (var i = 0; i < vm.report.length; i++) {
				var row = vm.report[i];
				row['callsCountP'] = row['callsCount'] * 100
						/ vm.maxData['callsCount'];
			}
		}

		function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					title : ' - '.repeat(level) + data[i].title
				});

				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}

	}
})();
